import Icon from '@/components/snippets/icon/icon'
import { isPriceFilterField, formatPriceValue, RANGE_INDICATOR } from './FilterUtils'
import { isSizeFilter, formatUniversalSizeValue } from './SizeFilterUtils'

export function FilterSelected({ activeFilters, onRemove, onClear }) {
  if (!activeFilters || activeFilters.size === 0) return null

  const formatFilterValue = (filter) => {
    const [field, value] = filter.split(':')

    if (isPriceFilterField(field)) {
      const [min, max] = value.split(RANGE_INDICATOR)
      return `${formatPriceValue(parseFloat(min))} ↔ ${formatPriceValue(parseFloat(max))}`
    }

    if (isSizeFilter(field, value)) {
      return formatUniversalSizeValue(value).replaceAll(RANGE_INDICATOR, '↔')
    }

    return value.replaceAll(RANGE_INDICATOR, '↔')
  }

  return (
    <div className="flex lg-max:flex-wrap lg:grid lg:grid-cols-min-auto-min items-center gap-0.5 w-fit lg:pl-1.5 lg:border-l lg:border-borders-default">
      <span className="lg-max:hidden paragraph-xs font-extended font-semibold whitespace-nowrap">Applied Filters:</span>
      <div className="flex lg-max:flex-wrap items-center gap-0.5 lg:overflow-x-scroll lg:no-scrollbar">
        {[...activeFilters].map((filter) => {
          return (
            <div className="flex items-center justify-center min-h-[44px]">
              <button
                className="shrink-0 btn btn-fill btn-custom btn-xs w-fit rounded-900 whitespace-nowrap"
                style="--button-colour: #272524; --button-colour-bg: #F3F0F1;"
                onClick={() => onRemove(filter)}
                aria-label={`Remove ${formatFilterValue(filter)} filter`}
              >
                <span>
                  {formatFilterValue(filter)}
                </span>
                <div className="flex size-[7px] children:size-full">
                  <Icon id="close" />
                </div>
              </button>
            </div>
          )
        })}
      </div>
      <button className="shrink-0 btn btn-text btn-tertiary btn-s w-fit whitespace-nowrap" onClick={onClear} aria-label="Clear all filters">
        <span className="text-line text-line-large">
          Clear All
        </span>
      </button>
    </div>
  )
}
